import { Dto, DtoWithId } from "@mango/core";
import { Projectgroep } from './projectgroep';
import { PostType } from './post-type';
import { Land } from "./land";
import { FactuurType } from "./factuur-type";
import { Contactpersoon } from "./contactpersoon";
import { Personeel } from "./personeel";
import { Relatie } from "./relatie";
import { Projectstatus } from "../enums/projectstatus";
import { Adres } from "./adres";

@Dto({fullName: "CIJBorculo.Logic.Project"})
export class Project extends DtoWithId {
	oldID: number;
	code: string;
	relatie: Relatie;
	projectgroep: Projectgroep;
	workflowID: number;
	status: Projectstatus;
	projectleider: Personeel;
	verzendContactpersoon: Contactpersoon;
	verzendAdres: Adres;
	verzendAdres1: string;
	verzendAdres2: string;
	verzendPostcode: string;
	verzendPlaats: string;
	verzendLand: Land;
	publicatieContactpersoon: Contactpersoon;
	publicatieAdres: Adres;
	publicatieNaam: string;
	publicatieAdres1: string;
	publicatieAdres2: string;
	publicatiePostcode: string;
	publicatiePlaats: string;
	publicatieLand: Land;
	referentieKlant: string;
	omschrijving2: string;
	eMail: string;
	datumAanvraag: Date;
	datumOrder: Date;
	datumStart: Date;
	datumPlan: Date;
	datumGereed: Date;
	opmerking: string;
	factuurType: FactuurType;
	postType: PostType;
	datumLeveren: Date;
	datumOBAangemaakt: Date;
	datumOBVerstuurd: Date;
}